var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaper({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "576E9577-6329-4323-8707-C47C92854141") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Meu-perfil",
    transform: "translate(-312.000000, -318.000000)",
    fill: "#B4B4B4",
    stroke: "#B4B4B4",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "paper",
    transform: "translate(313.000000, 319.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0882353,17 L4.91176471,17 C3.858,17 3,16.15925 3,15.125 L3,3.875 C3,2.84075 3.858,2 4.91176471,2 L14.0882353,2 C15.142,2 16,2.84075 16,3.875 L16,15.125 C16,16.15925 15.142,17 14.0882353,17 Z M4.91176471,2.75 C4.27935294,2.75 3.76470588,3.25475 3.76470588,3.875 L3.76470588,15.125 C3.76470588,15.74525 4.27935294,16.25 4.91176471,16.25 L14.0882353,16.25 C14.7206471,16.25 15.2352941,15.74525 15.2352941,15.125 L15.2352941,3.875 C15.2352941,3.25475 14.7206471,2.75 14.0882353,2.75 L4.91176471,2.75 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67647059,16 L1.91176471,16 C0.858,16 0,15.1459048 0,14.0952381 L0,1.9047619 C0,0.854095238 0.858,0 1.91176471,0 L11.0882353,0 C12.142,0 13,0.854095238 13,1.9047619 C13,2.11504762 12.8287059,2.28571429 12.6176471,2.28571429 C12.4065882,2.28571429 12.2352941,2.11504762 12.2352941,1.9047619 C12.2352941,1.27466667 11.7206471,0.761904762 11.0882353,0.761904762 L1.91176471,0.761904762 C1.27935294,0.761904762 0.764705882,1.27466667 0.764705882,1.9047619 L0.764705882,14.0952381 C0.764705882,14.7253333 1.27935294,15.2380952 1.91176471,15.2380952 L2.67647059,15.2380952 C2.88752941,15.2380952 3.05882353,15.4087619 3.05882353,15.6190476 C3.05882353,15.8293333 2.88752941,16 2.67647059,16 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6111111,7 L6.38888889,7 C6.17422222,7 6,6.776 6,6.5 C6,6.224 6.17422222,6 6.38888889,6 L12.6111111,6 C12.8257778,6 13,6.224 13,6.5 C13,6.776 12.8257778,7 12.6111111,7 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6111111,10 L6.38888889,10 C6.17422222,10 6,9.776 6,9.5 C6,9.224 6.17422222,9 6.38888889,9 L12.6111111,9 C12.8257778,9 13,9.224 13,9.5 C13,9.776 12.8257778,10 12.6111111,10 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6111111,13 L6.38888889,13 C6.17422222,13 6,12.776 6,12.5 C6,12.224 6.17422222,12 6.38888889,12 L12.6111111,12 C12.8257778,12 13,12.224 13,12.5 C13,12.776 12.8257778,13 12.6111111,13 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.88e8a94fc62f21a3de81c8c51ceb42a8.svg";
export { ForwardRef as ReactComponent };